import { getFunctions, httpsCallable } from "firebase/functions";
import toastHandler from "./toastHandler";
import {functions} from "../firebase"
import envUtils from "../utils/envUtils";

import { analytics } from "../firebase";
import { logEvent } from "@firebase/analytics";
import sentryUtils from "../utils/sentryUtils";

const enquiry = {
  addEnquiry: async (enquiryData) => {
    let toastId = 'processingEnquiryToast'
    toastHandler.loading("Processing...", toastId)
    
    let resData = httpsCallable(functions, "api/enquiry");
    if (envUtils.isProfileMatchesWithValue("emulator") || envUtils.isProfileMatchesWithValue("test")) {
      resData = httpsCallable(getFunctions(), "mondaybaseurl/api/enquiry");
    }
    const result = resData(enquiryData)
      .then((result) => {
        // Read result of the Cloud Function.
        const data = result.data;
        if(!data.error) {
          toastHandler.update(data, toastId, 'success')
          logEvent(analytics, 'add_enquiry', { "account_id": localStorage.getItem("accountId") });
        } else {
          const error = data.error;
          toastHandler.update(error, toastId, 'error')
          sentryUtils.captureAPIMessageException('addEnquiry', error, "EnquiryFunctions")
        }
        return true;
      })
      .catch((error) => {
        toastHandler.update(error, toastId, 'error')
        sentryUtils.captureAPIException('addEnquiry', error, "EnquiryFunctions")
        return false
      });
      return result
  },
};

export default enquiry;